import { getCheckoutReview } from '../../api'
import {
  checkoutAddressToForm,
  resolveNextStepFromSession,
  type CheckoutFlowAction,
} from '../CheckoutFlow.types'
import { classifyBootstrapError } from './errors'
import { resolveStepFromPopstate } from './navigation'

export const refreshCheckoutReview = async ({
  token,
  sessionId,
  dispatch,
  isCancelled,
  onReviewLoaded,
}: {
  token: string | null
  sessionId: string
  dispatch: (action: CheckoutFlowAction) => void
  isCancelled: () => boolean
  onReviewLoaded: (id: string) => void
}) => {
  try {
    const payload = await getCheckoutReview({ token, id: sessionId })
    if (isCancelled()) return

    dispatch({
      type: 'SESSION_UPDATED',
      session: payload.session,
      shippingAddressForm: checkoutAddressToForm(payload.session.shippingAddress),
      billingAddressForm: checkoutAddressToForm(payload.session.billingAddress),
      selectedShippingMethod: payload.session.shippingMethod?.code ?? 'standard',
      selectedPaymentProvider:
        payload.session.selectedPaymentProvider
        ?? payload.defaultPaymentProvider
        ?? 'bank_transfer',
      step: resolveStepFromPopstate({
        session: payload.session,
        fallbackStep: resolveNextStepFromSession(payload.session),
      }),
    })
    dispatch({
      type: 'REVIEW_UPDATED',
      review: payload.review,
      shippingMethods: payload.shippingMethods,
      paymentProviders: payload.paymentProviders ?? [],
      defaultPaymentProvider: payload.defaultPaymentProvider ?? 'bank_transfer',
    })
    onReviewLoaded(payload.session.id)
  } catch (error) {
    if (isCancelled()) return
    const mapped = classifyBootstrapError({ error, hasExistingSession: true })
    dispatch({ type: 'SET_ERROR', code: mapped.code, detail: mapped.detail })
  }
}
